var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/verification/registration.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/web.dom-collections.iterator.js";
import * as React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import { logIn, verifyCredentials } from 'soapbox/actions/auth';
import { fetchInstance } from 'soapbox/actions/instance';
import { startOnboarding } from 'soapbox/actions/onboarding';
import snackbar from 'soapbox/actions/snackbar';
import { createAccount, removeStoredVerification } from 'soapbox/actions/verification';
import { Button, Form, FormGroup, Input, Text } from 'soapbox/components/ui';
import { useAppDispatch, useAppSelector, useSoapboxConfig } from 'soapbox/hooks';
import { getRedirectUrl } from 'soapbox/utils/redirect';
import PasswordIndicator from './components/password-indicator';
const messages = defineMessages({
  success: {
    "id": "registrations.success",
    "defaultMessage": "Welcome to {siteTitle}!"
  },
  usernameHint: {
    "id": "registrations.username.hint",
    "defaultMessage": "May only contain A-Z, 0-9, and underscores"
  },
  usernameTaken: {
    "id": "registrations.unprocessable_entity",
    "defaultMessage": "This username has already been taken."
  },
  error: {
    "id": "registrations.error",
    "defaultMessage": "Failed to register your account."
  }
});
const initialState = {
  username: '',
  password: ''
};

const Registration = () => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const soapboxConfig = useSoapboxConfig();
  const {
    links
  } = soapboxConfig;
  const isLoading = useAppSelector(state => state.verification.isLoading);
  const siteTitle = useAppSelector(state => state.instance.title);
  const [state, setState] = React.useState(initialState);
  const [shouldRedirect, setShouldRedirect] = React.useState(false);
  const [hasValidPassword, setHasValidPassword] = React.useState(false);
  const {
    username,
    password
  } = state;
  const handleSubmit = React.useCallback(event => {
    event.preventDefault();
    dispatch(createAccount(username, password)).then(() => dispatch(logIn(username, password))).then(_ref => {
      let {
        access_token
      } = _ref;
      return dispatch(verifyCredentials(access_token));
    }).then(() => dispatch(fetchInstance())).then(() => {
      setShouldRedirect(true);
      removeStoredVerification();
      dispatch(startOnboarding());
      dispatch(snackbar.success(intl.formatMessage(messages.success, {
        siteTitle
      })));
    }).catch(error => {
      var _error$response;

      if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 422) {
        dispatch(snackbar.error(intl.formatMessage(messages.usernameTaken)));
      } else {
        dispatch(snackbar.error(intl.formatMessage(messages.error)));
      }
    });
  }, [username, password]);
  const handleInputChange = React.useCallback(event => {
    event.persist();
    setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      [event.target.name]: event.target.value
    }));
  }, []);

  if (shouldRedirect) {
    const redirectUri = getRedirectUrl();
    return /*#__PURE__*/React.createElement(Redirect, {
      to: redirectUri,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 98,
        columnNumber: 12
      }
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "pb-4 sm:pb-10 mb-4 border-b border-gray-200 dark:border-gray-800 border-solid -mx-4 sm:-mx-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-center font-bold text-2xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "registration.header",
    defaultMessage: "Register your account",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "sm:pt-10 sm:w-2/3 md:w-1/2 mx-auto space-y-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 110,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormGroup, {
    labelText: "Your username",
    hintText: intl.formatMessage(messages.usernameHint),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Input, {
    name: "username",
    type: "text",
    value: username,
    onChange: handleInputChange,
    required: true,
    icon: require('@tabler/icons/at.svg'),
    placeholder: "LibertyForAll",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(FormGroup, {
    labelText: "Password",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Input, {
    name: "password",
    type: "password",
    value: password,
    onChange: handleInputChange,
    required: true,
    "data-testid": "password-input",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(PasswordIndicator, {
    password: password,
    onChange: setHasValidPassword,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center space-y-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 136,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    block: true,
    theme: "primary",
    type: "submit",
    disabled: isLoading || !hasValidPassword,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 137,
      columnNumber: 13
    }
  }, "Register"), links.get('termsOfService') && links.get('privacyPolicy') ? /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    size: "xs",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "registration.acceptance",
    defaultMessage: "By registering, you agree to the {terms} and {privacy}.",
    values: {
      terms: /*#__PURE__*/React.createElement("a", {
        href: links.get('termsOfService'),
        target: "_blank",
        className: "text-primary-600 dark:text-primary-400 hover:underline",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 153,
          columnNumber: 23
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "registration.tos",
        defaultMessage: "Terms of Service",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 154,
          columnNumber: 25
        }
      })),
      privacy: /*#__PURE__*/React.createElement("a", {
        href: links.get('privacyPolicy'),
        target: "_blank",
        className: "text-primary-600 dark:text-primary-400 hover:underline",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 161,
          columnNumber: 23
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "registration.privacy",
        defaultMessage: "Privacy Policy",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 162,
          columnNumber: 25
        }
      }))
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 17
    }
  })) : null))));
};

export default Registration;